import React from 'react'
import { Avatar, AvatarImage, AvatarFallback } from 'components/ui/avatar'
import StyledPartnerAvatar from './PartnerAvatar.style'

export interface Props {
	className?: string
	name: string
	src?: string
	isOnline?: boolean
	size?: string
}

const PartnerAvatar = ({ className = '', name, src, size = '40', isOnline }: Props) => {
	return (
		<StyledPartnerAvatar
			data-testid="PartnerAvatar"
			className={className}
			isOnline={isOnline}
			size={size}
		>
			<Avatar><AvatarImage src={src} alt={name} /><AvatarFallback /></Avatar>
		</StyledPartnerAvatar>
	)
}

export default PartnerAvatar
